module.exports = __webpack_public_path__ + "img/loading.31be0995.svg";